module.exports = __webpack_public_path__ + "img/google.d914322e.png";